<template>
  
  <div class="ml-6 mr-6 mt-2" :style="navbarWithName ? 'margin-left: 150px !important; margin-right: auto !important;' : ''"> <!--note: mt,mb,ml,mr(margin) jangan diubah-->
    <v-row class="ma-6">
      <v-col cols="12" sm="6" md="3">
        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
          >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="startdate"
              label="Start Date"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
              >
            </v-text-field>
          </template>
          <v-date-picker v-model="startdate" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="menu = false">
              Cancel
            </v-btn>
            <v-btn text color="primary" @click="$refs.menu.save(date)">
              OK
            </v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="12" sm="6" md="3">
        <v-menu ref="menu2" v-model="menu2"  :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="enddate"
                    label="End Date"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
              >
              </v-text-field>
            </template>
            <v-date-picker v-model="enddate" no-title scrollable >
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="menu2 = false" >
                Cancel
              </v-btn>
              <v-btn text color="primary" @click="$refs.menu2.save(date)" >
                OK
              </v-btn>
            </v-date-picker>
        </v-menu>
      </v-col>
      
      <v-col  cols="12" sm="6" md="3">
          <v-btn
            dense
            color="#439EDF"
            dark
            rounded
            @click="search()"
          > 
            <v-icon class="ml-2">mdi-magnify</v-icon>
          </v-btn>
      </v-col>
      <v-col
        cols="12"
        sm="6"
        md="3"
        >
      </v-col>
    </v-row>
    <v-row wrap class="mb-4"  v-if="showMemoryCharts">
      
      <v-flex lg="4" sm="12" class="chart-container">
            <v-card-title>Memory Usag</v-card-title>
            <apexchart  height="240px"  type="donut" :options="chartOptions" :series="chartSeries" ></apexchart>
      </v-flex>


      <v-flex lg="4" sm="12" class="chart-container">
            <v-card-title>Swap Space</v-card-title>
            <apexchart  height="240px"  type="donut" :options="chartSwapOptions" :series="chartSwapSeries" ></apexchart>
      </v-flex>

      <v-flex lg="4" sm="12" class="chart-container">
            <v-card-title>File Descriptor Count </v-card-title>
            <apexchart  height="240px"  type="donut" :options="chartFileCountOptions" :series="chartFileCountSeries" ></apexchart>
      </v-flex>
    </v-row>
    <v-row wrap class="mb-4"  >
      <v-flex lg="6" sm="12" class="chart-container">
          <v-card-title >Available Memory (GB)</v-card-title>
          <div >            
            <apexchart  class="mr-3" type="area" :options="chartOptionsAvailabel" :series="chartSeriesAvailabel" ></apexchart>
          </div>
      </v-flex>
      <v-flex lg="6" sm="12" class="chart-container">
          <v-card-title >Used Memory (GB)</v-card-title>
          <div >      
            <apexchart  class="mr-3" type="area" :options="chartOptionsAvailabel" :series="chartSeriesUsage" ></apexchart>
          </div>
      </v-flex>
    </v-row>
    <!-- solr chart -->
     
    <v-row wrap class="mb-4"  >
      <v-flex lg="6"  sm="12" class="chart-container">
          <v-card-title >Solr Index</v-card-title>
          <div >      
            <apexchart  class="mr-3  small-chart" type="area" :options="chartOptionsSolr" :series="chartSeriesSolrIndex" 
            style="height: 200px;" 
            ></apexchart>
          </div>
      </v-flex>
      <v-flex lg="6"  sm="12" class="chart-container">
          <v-card-title >Solr CPU</v-card-title>
          <div >      
            <apexchart  class="mr-3  small-chart" type="area" :options="chartOptionsSolr" :series="chartSeriesSolrCpu" 
            style="height: 200px;" 
            ></apexchart>
          </div>
      </v-flex>
    </v-row>
    

    <v-row wrap class="mb-4"  >
      <v-flex lg="6" sm="12" class="chart-container">
          <v-card-title >JVM Heap</v-card-title>
          <div >      
            <apexchart  class="mr-3" type="area" :options="chartOptionsSolr" :series="chartSeriesJvmHeap" ></apexchart>
          </div>
      </v-flex>
      <v-flex lg="6" sm="12" class="chart-container">
          <v-card-title >JVM Non Heap</v-card-title>
          <div >            
            <apexchart  class="mr-3" type="area" :options="chartOptionsSolr" :series="chartSeriesJvm" ></apexchart>
          </div>
      </v-flex>
    </v-row>



    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h6 font-weight-medium align-center justify-center">
          Page loading
        </v-card-title>
        <v-card-text class="body-1 align-center justify-center">
          Loading content, please wait
        </v-card-text>
        <v-card-title class="align-center justify-center">
          <v-progress-circular
            :size="70"
            :width="7"
            color="#0471A5"
            indeterminate
          ></v-progress-circular>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#0471A5" text @click="dialog = false">
            cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from 'axios';
// import ApexCharts from 'apexcharts';
import VueApexCharts from 'vue-apexcharts'

export default {
  name: "MemoryUsageProgressBar",
  components: {
    apexchart: VueApexCharts
  },
  data() {
    return {

      dialog: false,
      startdate: new Date().toISOString().substr(0, 10),
      enddate: new Date().toISOString().substr(0, 10),

      showMemoryCharts: true, 
      totalSwapGb:0,
      totalSwap: 0,
      usedSwap: 0,
      freeSwap: 0,
      // == memory 
      chartSeries: [0, 0],  // Initial values for "Used" and "Free" memory
      chartOptions: {
        chart: {
          id: 'memory-usage-pie-chart',
          type: 'pie',
        },
        labels: ['Used Memory', 'Free Memory'],
        legend: {
          position: 'bottom',
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return `${val} GB`; // Show GB in tooltip
            }
          }
        },
        
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                name: {
                  show: true,
                  fontSize: '22px',
                  color: '#226077',
                  offsetY: -10,
                },
                total: {
                  show: true,
                  formatter: function (w) {
                    // Format the total value to two decimal places
                    return w.globals.seriesTotals.reduce((a, b) => a + b, 0).toFixed(2) + ' GB'; // Example: Show in GB
                  }
                },
              }
            }
          }
        },
      },
      // availabel ===
      chartOptionsAvailabel: {
        chart: {
          id: 'available-memory-line-chart',
          type: 'area', 
          animations: {
            enabled: true,
            // easing: 'linear',
            dynamicAnimation: {
              speed: 1000
            }
          },
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth',
          colors: ['#00E396', '#FF4560'],
        },
        xaxis: {
          type: 'datetime', // For time series data
        },
        yaxis: {
          title: {
            text: 'Memory (GB)',
          },
          // max: 30,
          // tickAmount: Math.floor(30 / 10), 
        },
        tooltip: {
          x: {
            format: 'dd MMM yyyy HH:mm:ss', // Format for datetime tooltip
          },
          y: {
            formatter: function (val) {
              return `${val} GB`;
            }
          }
        },
        legend: {
          position: 'top',
        },
      },
      chartSeriesAvailabel: [{
        name: 'Available Memory',
        data: this.loadChartData('availableMemoryData') || [],
      }],
      chartSeriesUsage: [{
        name: 'Used Memory',
        data: this.loadChartData('usedMemoryData') || [],
      }],

      chartOptionsSolr: {
        chart: {
          id: 'solr-memory-line-chart',
          type: 'area', 
          animations: {
            enabled: true,
            dynamicAnimation: {
              speed: 1000
            }
          },
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth',
          colors: ['#00E396', '#FF4560'],
        },
        xaxis: {
          type: 'datetime', // For time series data
        },
        yaxis: {
          title: {
            text: 'Memory',
          },
        },
        tooltip: {
          x: {
            format: 'dd MMM yyyy HH:mm:ss', // Format for datetime tooltip
          },
          y: {
            formatter: function (val) {
              return `${val}`;
            }
          }
        },
        legend: {
          position: 'top',
        },
      },
      chartSeriesSolrIndex: [{
        name: 'Solr Index ',
        data: [],
      }],
      chartSeriesSolrCpu: [{
        name: 'Solr CPU ',
        data: [],
      }],
      chartSeriesJvmHeap: [{
        name: 'JVM Heap ',
        data: [],
      }],
      
      chartSeriesJvm: [{
        name: 'JVM Non Heap',
        data: [],
      }],
      

      // == swap 
      chartSwapSeries: [0, 0],  // Initial values for "Used" and "Free" memory
      chartSwapOptions: {
        chart: {
          id: 'swap-pie-chart',
          type: 'pie',
        },
        labels: ['Used Swap', 'Free Swap'],
        legend: {
          position: 'bottom',
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return `${val} GB`; // Show GB in tooltip
            }
          }
        },
        
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                name: {
                  show: true,
                  fontSize: '22px',
                  color: '#226077',
                  offsetY: -10,
                },
                total: {
                  show: true,
                  formatter: function (w) {
                    // Format the total value to two decimal places
                    return w.globals.seriesTotals.reduce((a, b) => a + b, 0).toFixed(2) + ' GB'; // Example: Show in GB
                  }
                },
              }
            }
          }
        },
      },
      // == file count 
      chartFileCountSeries: [0, 0],  // Initial values for "Used" and "Free" memory
      chartFileCountOptions: {
        chart: {
          id: 'file-pie-chart',
          type: 'pie',
        },
        labels: ['Used File Count', 'Available File Count'],
        legend: {
          position: 'bottom',
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return `${val} File`; // Show GB in tooltip
            }
          }
        },
        
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                name: {
                  show: true,
                  fontSize: '22px',
                  color: '#226077',
                  offsetY: -10,
                },
                total: {
                  show: true,
                  formatter: function (w) {
                    // Format the total value to two decimal places
                    return w.globals.seriesTotals.reduce((a, b) => a + b, 0); // Example: Show in GB
                  }
                },
              }
            }
          }
        },
      },
      
    };
  },
  mounted() {
    this.fetchMemoryData();
    // setInterval(this.fetchMemoryData, 10000); // Fetch memory data every 10 seconds
  },
  methods: {
    // Fungsi untuk mengubah format tanggal
    showCustomDate() {
      var date = new Date(this.date1);
      var day2 = (date.getMonth() > 8 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)) + "/" +
        (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) + "/" +
        date.getFullYear();

      const parts = day2.split("/");
      parts.unshift(parts.pop());
      parts[1] -= 1;
      var dateString = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "UTC"
      }).format(Date.UTC(...parts)).replace(/,/g, "");

      dateString = dateString.split(" ");
      this.showDate1 = dateString;

      var date3 = new Date(this.date2);
      var day4 = (date3.getMonth() > 8 ? date3.getMonth() + 1 : "0" + (date3.getMonth() + 1)) + "/" +
        (date3.getDate() > 9 ? date3.getDate() : "0" + date3.getDate()) + "/" +
        date3.getFullYear();

      const parts2 = day4.split("/");
      parts2.unshift(parts2.pop());
      parts2[1] -= 1;
      var dateString2 = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "UTC"
      }).format(Date.UTC(...parts2)).replace(/,/g, "");

      dateString2 = dateString2.split(" ");
      this.showDate2 = dateString2;
    },
    // Fungsi untuk memproses pengaturan periode kustom
    parameter_proses_custom() {
      this.selectedPeriode = "Custom";
    },
    
    async parameter_proses_periode() {
      var date_start = this.date1;
      var date_end = this.date2;
      const date_awal = new Date();
      const date = new Date();
      date.setDate(date.getDate() + 0);
      const datenow = date.toISOString().substr(0, 10);
      if (this.selectedPeriode == "Today") {
        this.click = "Today";
        date_start = datenow;
        date_end = datenow;
      }
      if (this.selectedPeriode == "Yesterday") {
        this.click = "Yesterday";
        date_awal.setDate(date_awal.getDate() - 1);
        const date_c = date_awal.toISOString().substr(0, 10);
        date_start = date_c;
        date_end = date_c;
      }
      if (this.selectedPeriode == "Last 7 Days" || this.selectedPeriode == "Previous Week") {
        this.click = "Last 7 Days";
        date_awal.setDate(date_awal.getDate() - 7);
        const date_c = date_awal.toISOString().substr(0, 10);
        date_start = date_c;
        date_end = datenow;
      }
      if (this.selectedPeriode == "Last 30 Days" || this.selectedPeriode == "Previous Month") {
        this.click = "Last 30 Days";
        date_awal.setDate(date_awal.getDate() - 30);
        const date_c = date_awal.toISOString().substr(0, 10);
        date_start = date_c;
        date_end = datenow;
      }
      
      // this.loadKontenBerita2()
      this.startdate = date_start;
      this.enddate = date_end;
    },


    search() {
      this.fetchMemoryData()

    },
    saveChartData(key, data) {
      localStorage.setItem(key, JSON.stringify(data));
    },
    // Load the chart data from localStorage
    loadChartData(key) {
      const data = localStorage.getItem(key);
      return data ? JSON.parse(data) : null; // Parse JSON string or return null if not found
    },

    toggleMemoryCharts() {
      this.showMemoryCharts = !this.showMemoryCharts;
    },
    async fetchMemoryData() {
      this.dialog = true;

      // Prometheus query for memory usage
      const totalMemoryQuery = 'node_memory_MemTotal_bytes';
      const freeMemoryQuery = 'node_memory_MemFree_bytes';
      const usageMemoryQuery = 'node_memory_MemTotal_bytes - node_memory_MemFree_bytes';
      const prometheusUrl = 'http://172.20.4.11:9090/api/v1/query';
      const prometheusUrlRange = 'http://172.20.4.11:9090/api/v1/query_range';
      
      // Tanggal yang ingin dikonversi
      console.log(this.startdate)
      const date = new Date(this.startdate + 'T00:00:00Z'); // Mengasumsikan waktu di UTC
      const unixTimestamp = date.getTime() / 1000; // Menghasilkan detik, bukan milidetik
      const startdate = unixTimestamp + 0.24; // Menambahkan pecahan detik

      const date_end = new Date(this.enddate + 'T23:59:59Z'); // Menggunakan detik terakhir (23:59:59)
      const unixTimestamp_end = date_end.getTime() / 1000; // Menghasilkan detik, bukan milidetik
      const enddate = unixTimestamp_end + 0.24; // Menambahkan pecahan detik
      try {
        //====== availabel memory pie ====
        // Fetching Total Memory
        const totalMemoryResponse = await axios.get(prometheusUrlRange, {
          params: { 
            query: totalMemoryQuery,
            start: startdate,
            end: enddate,
            step:60
          },
        });
        // Fetching Free Memory
        const freeMemoryResponse = await axios.get(prometheusUrlRange, {
          params: { 
            query: freeMemoryQuery,
            start: startdate,
            end: enddate,
            step:60
          },
        });
        // Check if the Prometheus response contains the expected data
        const totalMemoryData = totalMemoryResponse.data.data.result;
        const freeMemoryData = freeMemoryResponse.data.data.result;
        let totalMemory = ""
        // Ensure that data exists before trying to access it
        if (totalMemoryData && totalMemoryData.length > 0 && totalMemoryData[0].values.length > 0) {
          // Get the most recent value from the "values" array (last element)
          totalMemory = parseFloat(totalMemoryData[0].values[totalMemoryData[0].values.length - 1][1]);
          console.log('Total Memory:', totalMemory);
        } else {
          console.error('Error: Total memory data is missing or empty');
        }
        let freeMemory = ""
        if (freeMemoryData && freeMemoryData.length > 0 && freeMemoryData[0].values.length > 0) {
          // Get the most recent value from the "values" array (last element)
          freeMemory = parseFloat(freeMemoryData[0].values[freeMemoryData[0].values.length - 1][1]);
          console.log('Free Memory:', freeMemory);
        } else {
          console.error('Error: Free memory data is missing or empty');
        }
        // If both values are valid, calculate used memory
        if (typeof totalMemory === 'number' && typeof freeMemory === 'number') {
          const usedMemory = totalMemory - freeMemory;
          // Convert to GB and set chart values
          const freeMemoryInGB = (freeMemory / (1024 * 1024 * 1024)).toFixed(2);  // Convert from bytes to GB
          const usedMemoryGB = (usedMemory / (1024 * 1024 * 1024)).toFixed(2);  // Convert from bytes to GB

          this.chartSeries = [parseFloat(usedMemoryGB), parseFloat(freeMemoryInGB)];
        }

        //====== availabel memory grafik ====
        // Fetching Free Memory
        const freeMemoryRange = await axios.get(prometheusUrlRange, {
          params: { 
            query: freeMemoryQuery,
            start: startdate,
            end: enddate,
            step:14
          },
        });
        // Menangani data yang dikembalikan
        const data = freeMemoryRange.data.data.result[0].values;  // Mengambil values dari response
        // Mengolah data untuk grafik
        const chartData = data.map(item => {
          const timestamp = new Date(item[0] * 1000);  // Mengonversi timestamp Unix ke objek Date
          const memoryInGB = item[1] / (1024 * 1024 * 1024);  // Mengonversi byte ke GB
          return [timestamp.getTime(), (memoryInGB).toFixed(2)];  // Format untuk ApexCharts
        });
        // Update data di grafik
        this.chartSeriesAvailabel[0].data = chartData;
        console.log(chartData)
        // Fetching Usage Memory
        const usedMemoryRange = await axios.get(prometheusUrlRange, {
          params: { 
            query: usageMemoryQuery,
            start: startdate,
            end: enddate,
            step:14
          },
        });
        // Menangani data yang dikembalikan
        const dataUsed = usedMemoryRange.data.data.result[0].values;  // Mengambil values dari response
        // Mengolah data untuk grafik
        const chartDataUsed = dataUsed.map(item => {
          const timestamp = new Date(item[0] * 1000);  // Mengonversi timestamp Unix ke objek Date
          const memoryInGB = item[1] / (1024 * 1024 * 1024);  // Mengonversi byte ke GB
          return [timestamp.getTime(), (memoryInGB).toFixed(2)];  // Format untuk ApexCharts
        });
        // Update data di grafik
        this.chartSeriesUsage[0].data = chartDataUsed;

        //====== swap memory ====
        const totalSwapQuery = 'node_memory_SwapTotal_bytes';
        const usedSwapQuery = 'node_memory_SwapUsed_bytes';
        const freeSwapQuery = 'node_memory_SwapFree_bytes';
        const totalSwapResponse = await axios.get(prometheusUrl, {
          params: { 
            query: totalSwapQuery
          },
        });
        const usedSwapResponse = await axios.get(prometheusUrl, {
          params: { 
            query: usedSwapQuery
          },
        });
        const freeSwapResponse = await axios.get(prometheusUrl, {
          params: { 
            query: freeSwapQuery
          },
        });
        let totalSwap = 0;
        let usedSwap = 0;
        let freeSwap = 0;
        if (totalSwapResponse.data.data.result.length > 0) {
          totalSwap = parseFloat(totalSwapResponse.data.data.result[0].value[1]);
        }
        if (freeSwapResponse.data.data.result.length > 0) {
          freeSwap = parseFloat(freeSwapResponse.data.data.result[0].value[1]);
        }
        // Calculate the free swap space as totalSwap - usedSwap if it's not available
        if (isNaN(freeSwap) && !isNaN(totalSwap) && !isNaN(usedSwap)) {
          freeSwap = totalSwap - usedSwap;
        }
        if (usedSwapResponse.data.data.result.length > 0) {
          usedSwap = parseFloat(usedSwapResponse.data.data.result[0].value[1]);
        }else{
          usedSwap = totalSwap - freeSwap;
        }
        // Store the swap data
        this.totalSwap = totalSwap;
        this.usedSwap = usedSwap;
        this.freeSwap = freeSwap;
        const usedSwapInGB = (this.usedSwap / (1024 * 1024 * 1024)).toFixed(2); // Used Swap in GB
        const freeSwapInGB = (this.freeSwap / (1024 * 1024 * 1024)).toFixed(2); // Free Swap in GB
        this.totalSwapGb = (this.totalSwap / (1024 * 1024 * 1024)).toFixed(2); // Total Swap in GB
        this.chartSwapSeries = [parseFloat(usedSwapInGB), parseFloat(freeSwapInGB)];
        //====== end swap memory ====


        // ==== file count ====
        
        const fileAvail = 'node_memory_Active_file_bytes';
        const filefree = 'node_memory_Inactive_file_bytes';
        const countavail = await axios.get(prometheusUrl, {
          params: { 
            query: fileAvail
          },
        });
        const countUsed = await axios.get(prometheusUrl, {
          params: { 
            query: filefree
          },
        });

        // Mengekstrak nilai dari respons Prometheus (value[1] adalah nilai metrik)
        const availCount = parseFloat(countavail.data.data.result[0].value[1]);
        const usedCount = parseFloat(countUsed.data.data.result[0].value[1]);
        this.chartFileCountSeries = [parseFloat(usedCount), parseFloat(availCount)];


        // solr 
        
        // 
        
        const solr_index = await axios.get(prometheusUrlRange, {
          params: { 
            query: 'solr_metrics_core_index_size_bytes',
            start: startdate,
            end: enddate,
            step:14
          },
        });
        const data_solr_index = solr_index.data.data.result[0].values;  // Mengambil values dari response
        const chartDataSolrindex = data_solr_index.map(item => {
          const timestamp = new Date(item[0] * 1000);  // Mengonversi timestamp Unix ke objek Date

          const memoryInGB = (item[1]);  // Mengonversi byte  
          return [timestamp.getTime(), (memoryInGB)]; 
        });
        this.chartSeriesSolrIndex[0].data = chartDataSolrindex;



        const solr_cpu = await axios.get(prometheusUrlRange, {
          params: { 
            query: 'rate(solr_metrics_jvm_os_cpu_load[60m])',
            start: startdate,
            end: enddate,
            step:14
          },
        });
        const data_solr_cpu = solr_cpu.data.data.result[0].values;  // Mengambil values dari response
        const chartDataSolrCpu = data_solr_cpu.map(item => {
          const timestamp = new Date(item[0] * 1000);  // Mengonversi timestamp Unix ke objek Date
          const memoryInGB = (item[1]);  // Mengonversi byte  
          return [timestamp.getTime(), (memoryInGB)]; 
        });
        this.chartSeriesSolrCpu[0].data = chartDataSolrCpu;

        const jvm_heap = await axios.get(prometheusUrlRange, {
          params: { 
            query: 'solr_metrics_jvm_memory_heap_bytes',
            start: startdate,
            end: enddate,
            step:14
          },
        });
        const data_jvm_heap = jvm_heap.data.data.result[0].values;  // Mengambil values dari response
        const chartDataJvmHeap = data_jvm_heap.map(item => {
          const timestamp = new Date(item[0] * 1000);  // Mengonversi timestamp Unix ke objek Date
          const memoryInGB = item[1] / (1024 * 1024 * 1024);  // Mengonversi byte ke GB
          return [timestamp.getTime(), (memoryInGB).toFixed(2)];  // Format untuk ApexCharts
        });
        this.chartSeriesJvmHeap[0].data = chartDataJvmHeap;


        const jvm_non_heap = await axios.get(prometheusUrlRange, {
          params: { 
            query: 'solr_metrics_jvm_memory_non_heap_bytes',
            start: startdate,
            end: enddate,
            step:14
          },
        });
        const data_jvm = jvm_non_heap.data.data.result[0].values;  // Mengambil values dari response
        const chartDataJvm = data_jvm.map(item => {
          const timestamp = new Date(item[0] * 1000);  // Mengonversi timestamp Unix ke objek Date
          const memoryInGB = item[1] / (1024 * 1024 * 1024);  // Mengonversi byte ke GB
          return [timestamp.getTime(), (memoryInGB).toFixed(2)];  // Format untuk ApexCharts
        });
        this.chartSeriesJvm[0].data = chartDataJvm;

        


        this.dialog = false;
      } catch (error) {
        this.dialog = false;

        console.error("Error fetching memory data from Prometheus:", error);
      }
    },
    swapMemory() {

    },
  },
};
</script>

<style> /*note css jangan diubah*/
/* Apply shadow effect to all chart containers */
.chart-container {
  
  /* width: 100%; 
  height: 400px;  */

  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.1);
  /* padding: 10px; */
  border-radius: 8px; /* Rounded corners */
  margin-bottom: 10px; /* Margin below each chart */
  margin-left: 10px;   /* Margin on the left of each chart */
  margin-right: 10px;  /* Margin on the right of each chart */
}

/* Targeting specific classes */
.apexcharts-canvas {
  width: 100% !important; 
  margin-left: 5px;
  margin-right: 5px;
  height: 250px !important;
}

.apexcharts-svg {
  margin: 0;
}

.apexchartsavailable-memory-line-chart {
  /* Adjust width, margin or padding if needed */
  width: 100% !important; 
  height: 240px !important; /* Adjust height if necessary */
}

.apexcharts-theme-light .apexcharts-xaxis-texts tspan {
  /* Example of changing text color of X-axis labels */
  fill: #226077;
}

.v-sheet--offset {
  top: -24px;
  position: relative;
}
div.apexcharts-canvas.apexcharts-theme-dark {
  background: transparent !important;
}

.tooltip .tooltip-inner {
  max-width: 100px !important;
  width: 100px !important;
}
.v-tooltip__content {
  font-size: 12px !important;
  max-width: 150px;
}
.row-pointer {
  cursor: pointer;
}

.btn-ok {
  background-image:
  linear-gradient(to right top, #53d166, #5dd468, #65d769, #6eda6b, #76dd6d, #7ee06f, #86e271, #8de573, #96e876, #9fec79, #a8ef7c, #b1f27f);
}
.v-avatar.color-avatar {
  background-image:
  linear-gradient(to right top, #5a6fe8, #6174ea, #6879ed, #6f7fef, #7584f1, #7d8af3, #8590f5, #8d96f7, #989ff9, #a2a7fb, #acb0fd, #b6b9ff);
}
.v-avatar.color-avatar2 {
  background-image:
  linear-gradient(to right top, #ec6497, #ef6d94, #f27693, #f47f92, #f58892, #f78f91, #f99791, #fa9e91, #fca690, #fdae8f, #feb690, #febe91);
}
.v-avatar.color-avatar3 {
  background-image:
  linear-gradient(to right top, #5d8de3, #5c92e4, #5b96e5, #5c9be6, #5d9fe6, #5da3e7, #5ea6e7, #5faae8, #5faee9, #5fb2ea, #60b6eb, #61baec);
}
.buttonstyle {
  box-shadow: 0 5px 15px rgba(153, 0, 255, 0.4);
  background-image:
  linear-gradient(to right top, #5a6fe8, #6174ea, #6879ed, #6f7fef, #7584f1, #7d8af3, #8590f5, #8d96f7, #989ff9, #a2a7fb, #acb0fd, #b6b9ff);
}
.v-avatar.color-avatar5 {
  background-image:
  linear-gradient(to right top, #dc922b, rgb(198, 128, 14), #fec864, #ffcc5e, #ffd057, #ffd359, #ffd65a, #ffd95c, #ffdb66, #ffde6f, #ffe079, #ffe282);
}
  
</style>